import React from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from '@mui/material';

const markdownExamples = [
  { syntax: '# Heading', result: 'Large heading' },
  { syntax: '## Heading', result: 'Smaller heading' },
  { syntax: '**bold**', result: 'Bold text' },
  { syntax: '*italic*', result: 'Italic text' },
  { syntax: '~~strikethrough~~', result: 'Strikethrough text' },
  { syntax: '- item\n- item', result: 'Bullet list' },
  { syntax: '1. item\n2. item', result: 'Numbered list' },
  { syntax: '> quote', result: 'Blockquote' },
  { syntax: '`code`', result: 'Inline code' },
  { syntax: '[link](url)', result: 'Hyperlink' },
  { syntax: '---', result: 'Horizontal line' },
];

function MarkdownGuide() {
  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle2" gutterBottom>
        Markdown Guide
      </Typography>
      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableBody>
            {markdownExamples.map((example) => (
              <TableRow key={example.syntax}>
                <TableCell>
                  <code>{example.syntax}</code>
                </TableCell>
                <TableCell>{example.result}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default MarkdownGuide;